import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { formBuilderConstants } from '../../formbuilder';

const results = {
  success: {
    next: newStepValue,
    description: 'Funds reservation was successful',
  },
  error: {
    next: newStepValue,
    description: 'Error',
  },
  cancelDeleteCard: {
    next: newStepValue,
    description: 'Cancel Deleting a card',
  },
};

const managementsOperation = {
  json: {
    menu: {
      name: '',
      menuType: 'payment',
      payment: {
        operationType: '',
        cardText: '',
        noCardsText: '',
        deleteCardConfirmationText: '',
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.name',
    'menu.payment.operationType',
    'menu.payment.cardText',
    'menu.payment.noCardsText',
    'menu.payment.deleteCardConfirmationText',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.name',
        'menu.payment.operationType',
        'menu.payment.cardText',
        'menu.payment.noCardsText',
        'menu.payment.deleteCardConfirmationText',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

const paymentOperation = {
  json: {
    menu: {
      name: '',
      menuType: 'payment',
      payment: {
        operationType: '',
        amount: '',
        linkText: '',
        cardText: '',
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.name',
    'menu.payment.operationType',
    'menu.payment.amount',
    'menu.payment.linkText',
    'menu.payment.cardText',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.name',
        'menu.payment.operationType',
        'menu.payment.amount',
        'menu.payment.linkText',
        'menu.payment.cardText',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
};

export const payment = {
  json: {
    menu: {
      name: '',
      menuType: 'payment',
      payment: {
        operationType: formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE,
      },
      results: results,
    },
    type: 'menu',
    metadata: {},
  },
  paths: ['menu.name', 'menu.payment.operationType', 'menu.results.#'],
  groups: [
    {
      Parameters: ['menu.name', 'menu.payment.operationType'],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    operationType: {
      type: 'dropdown',
      label: 'Operation Type',
      attributes: {
        options: {
          [formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE]:
            formBuilderConstants.DEFAULT_SELECT_OPTION_DESCRIPTION,
          payment: 'Payment',
          management: 'Management',
        },
        data: true
      },
      validators: {
        optionSelected: true,
      },
    },
    cardText: {
      type: 'textarea',
      label: 'Card text',
      validators: {
        required: true,
      },
    },
    noCardsText: {
      type: 'text',
      label: 'No cards text',
      validators: {
        required: true,
      },
    },
    deleteCardConfirmationText: {
      type: 'text',
      label: 'Delete card confirmation text',
      validators: {
        required: true,
      },
    },
    amount: {
      type: 'text',
      label: 'Amount',
      validators: {
        required: true,
      },
    },
    linkText: {
      type: 'textarea',
      label: 'Link text',
      validators: {
        required: true,
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          attributes: {
            readonly: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    dataPath: 'menu.payment.operationType',
    operationType: {
      payment: paymentOperation,
      management: managementsOperation,
    },
    results: {
      next: newStepValue,
      description: '',
    },
  },
};
